import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { authenticate } from "./utils/firebase";
import customClientAxios from "./customAxios";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [adminUser, setAdminUser] = useState(null);

  const verifyAdmin = useCallback(async (firebaseUser) => {
    try {
      const idToken = await firebaseUser.getIdToken();
      const res = await customClientAxios().post("/admin-auth/google-login", { idToken });
      if (res.data.success) {
        setAdminUser(res.data.data);
        setIsLoggedIn(true);
      } else {
        await signOut(authenticate);
        setIsLoggedIn(false);
        setAdminUser(null);
      }
    } catch {
      await signOut(authenticate);
      setIsLoggedIn(false);
      setAdminUser(null);
    }
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authenticate, async (firebaseUser) => {
      if (firebaseUser) {
        await verifyAdmin(firebaseUser);
      } else {
        setIsLoggedIn(false);
        setAdminUser(null);
      }
      setIsLoading(false);
    });
    return () => unsubscribe();
  }, [verifyAdmin]);

  const logout = async () => {
    await signOut(authenticate);
    setIsLoggedIn(false);
    setAdminUser(null);
  };

  if (isLoading) {
    return (
      <div style={{
        minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
        background: "linear-gradient(135deg, #0a0f1c 0%, #1a1f3c 50%, #0a0f1c 100%)",
        color: "#94a3b8", fontSize: 14,
      }}>
        Loading...
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, adminUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
